@import './pn-sidenav-common.scss';
@import '../../../globals/main.scss';

pn-sidenav-link {
  display: flex;
  flex-wrap: wrap;
}

.pn-sidenav-link {
  font-weight: normal;
  position: relative;
  border: 0 none;
  display: flex;
  align-items: center;
  background-color: transparent;
  color: $blue700;
  font-size: 1em;
  padding: 1.1rem 1.5rem 1.1rem;
  overflow: hidden;
  text-decoration: none;
  cursor: pointer;
  flex-grow: 1;

  &::before {
    content: '';
    display: block;
    width: 0.4rem;
    border-top-right-radius: 0.3rem;
    border-bottom-right-radius: 0.3rem;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    transform: translateX(-0.4rem);
    background: $blue700;
    transition: transform linear 0.35s;
  }
  &:hover,
  &:focus,
  [current='true'] > & {
    background-color: $blue50;
    color: $blue700;
    outline: 0;
    box-shadow: none;
    &::before {
      transform: none;
    }
  }
  &:active {
    background-color: $gray50;
    color: $blue400;
    box-shadow: none;
  }

  > pn-icon {
    padding-right: 1em;
  }
}

.pn-sidenav-link-expand {
  margin-left: auto;
  border: 0;
  font-size: 1em;
  background: transparent;
  outline: 0;
  padding: 0 1em 0 0.5em;
  cursor: pointer;

  &:hover,
  &:focus,
  [current='true'] > & {
    background-color: $blue50;
    color: $blue700;
    outline: 0;
    box-shadow: none;
    &::before {
      transform: none;
    }
  }

  button > & {
    padding-right: 0;
  }
  pn-icon {
    width: 14px;
  }
}
